import { Grid, Typography } from "@mui/material";
import AppWrapperContainer from "../../components/AppWrapperContainer";
import { PRIVACY_LIST } from "../../data/StaticList";
import AppFooter from "../../components/AppFooter";
import Accordion from "../../components/Accordion";
import Footer from "../../components/Footer";
import Seo from "../../components/Seo";

function PrivacyPolicy() {
  return (
    <>
      <Seo
        title="GroMo: Privacy Policy"
        description="Privacy policy is applicable for each user who visit & access company's website. For registration purpose company will collect some personal data, but company will protect it in all respects."
        keywords="GroMo Money Making Application"
        openGraph={{
          title: "GroMo: Privacy Policy",
          description:
            "Privacy policy is applicable for each user who visit & access company's website. For registration purpose company will collect some personal data, but company will protect it in all respects.",
          type: "website",
          image:
            "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp",
        }}
        twitter={{
          title: "Become A Certified Financial Advisor,Earn Money upto ₹1 Lakh",
          description:
            "Become a partner and make a regular income by selling financial products. Brand yourself as a certified financial advisor and launch and grow your business.",
          url: "https://gromo.in/privacy-policy",
          image:
            "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp",
        }}
      />
      <AppWrapperContainer nav navBgColor="white">
        <Grid
          paddingTop={4}
          style={{
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed",
          }}
        >
          <Grid
            className="container"
            style={{
              paddingBottom: "16px",
            }}
          >
            <>
              <Typography
                fontWeight={600}
                style={{
                  fontSize:'14px',
                  width: "fit-content",
                  borderBottom: "3px solid",
                  marginBottom: 16,
                }}
              >
                Privacy Policy
              </Typography>
            </>
            <Grid
              style={{
                background: "#fffffff2",
                boxShadow: "0px 0px 2px 0px grey",
                borderRadius: 8,
                padding: "0px 0px 0 0 ",
              }}
            >
              <Accordion items={PRIVACY_LIST} />

              <Grid sx={{ paddingLeft: "2rem" }}>
                <Typography
                  fontSize={"16px"}
                  sx={{ margin: "10px 0", fontWeight: "500" }}
                >
                  16 . NODAL GRIEVANCE OFFICER
                </Typography>
                <Typography fontSize={"16px"} sx={{ margin: "10px 0" }}>
                  The Company has appointed a Nodal Grievance Officer to redress
                  customer grievances relating to any digital lending-related
                  complaints. The name and contact details of the Nodal
                  Grievance Officer are provided below:
                </Typography>
                <Grid sx={{ paddingLeft: "42px" }}>
                  <Typography fontSize={"16px"} sx={{ margin: "10px 0" }}>
                    <span style={{ fontWeight: 700 }}> Name:</span> Rajat Gupta
                  </Typography>
                  <Typography fontSize={"16px"} sx={{ margin: "10px 0" }}>
                    <span style={{ fontWeight: 700 }}> E-mail:</span>{" "}
                    support@gromo.in
                  </Typography>
                  <Typography fontSize={"16px"} sx={{ margin: "10px 0" }}>
                    <span style={{ fontWeight: 700 }}> Contact number - </span>{" "}
                    8384030103
                  </Typography>
                  <Typography fontSize={"16px"} sx={{ margin: "10px 0" }}>
                    <span style={{ fontWeight: 700 }}>Address -</span> Vitrak
                    Technologies Private Limited, 3rd floor, Plot no. 130, Sector 44, Gurgaon 122003, Haryana
                  </Typography>
                </Grid>
                <Typography
                  fontSize={"16px"}
                  sx={{ margin: "10px 0", paddingBottom: "16px" }}
                >
                  If you have questions, concerns, or suggestions regarding our
                  Privacy Policy, we can be reached using the contact
                  information on our Contact Us page or at support@gromo.in.
                </Typography>
              </Grid>
            </Grid>
            <Footer />
          </Grid>
        </Grid>
      </AppWrapperContainer>
      <AppFooter />
    </>
  );
}

export default PrivacyPolicy;
